import { render, staticRenderFns } from "./PromotionShops.vue?vue&type=template&id=63fb8125"
import script from "./PromotionShops.vue?vue&type=script&lang=js"
export * from "./PromotionShops.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports